import { TAvailabilitySlot } from '@hcstechnologies/fuocos-interfaces/src/types';
import React from 'react';
import { ButtonBase, Typography, Stack, SxProps } from '@mui/material';
import FormatDate from '../components/format-date';

type SlotButtonArgs = {
    slot: TAvailabilitySlot;
    onSelect: (ev: React.MouseEvent<HTMLButtonElement>) => void;
    selected: boolean;
};

const SlotButton: React.FC<SlotButtonArgs> = ({ slot, onSelect, selected }) => {

    const standardStyle: SxProps = {
        width: '75px',
        borderRadius: '10px',
        border: '1px solid gray',
        margin: 1,
        paddingTop: '5px',
        paddingBottom: '5px'
    };

    const selectedStyle: SxProps = {
        ...standardStyle,
        variant: 'contained',
        backgroundColor: 'secondary.light',
    };


    return (
        <ButtonBase onClick={onSelect} sx={selected ? selectedStyle : standardStyle}>

            <Stack>
                <Typography variant='body2'>
                    <FormatDate date={slot.from} />
                </Typography>
                {slot.deliveryPrice && (
                    <Typography variant='body2'>
                        £{slot.deliveryPrice.toFixed(2)}
                    </Typography>
                )}

                {/*{slot.status.map(val => <Typography variant='caption' key={val}>{val}</Typography>)}*/}

            </Stack>
        </ButtonBase >
    );
};

export default SlotButton;
